import { stateful } from '@adornis/functional-lit/stateful.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { html } from 'lit';
import * as m from '../../localization/out/messages.js';
import { APP_VERSION } from '../../version.js';
import { LanguageToggle } from '../components/language-toggle.js';

export const ProfilePage = stateful(
  () => html`
    <div class="px-4 py-6 max-w-2xl mx-auto flex flex-col gap-6">
      <div>
        <h1 class="text-2xl font-bold">${m.profile_title()}</h1>
        <p class="text-sm text-base-content/60">${m.profile_subtitle()}</p>
      </div>

      <div class="gap-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="font-medium">${m.language_toggle_label()}</p>
            <p class="text-sm text-base-content/60">${m.language_select_hint()}</p>
          </div>
          ${LanguageToggle()}
        </div>

        <div class="divider"></div>

        <button
          class="btn btn-error btn-outline w-full"
          @click=${() => {
            void logout();
          }}
        >
          <span class="icon-[material-symbols--logout] text-lg"></span>
          ${m.nav_logout()}
        </button>
      </div>

      <p class="text-center text-xs text-base-content/40">Version ${APP_VERSION}</p>
    </div>
  `,
);
